import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ORDER_TEMPLATES = `${TASK_SERVICE}/order-templates`;

export const orderTemplates = {
  getAll: async ({ filters, sort, params, signal, top, skip, query } = {}) => {
    const options = await apiOptions({
      url: API_ORDER_TEMPLATES,
      method: "get",
      signal,
      params,
      filters,
      sort,
      top,
      skip,
      query,
    });
    return apiRequest(options);
  },
  getAllCreatable: async ({
    filters,
    sort,
    params,
    signal,
    top,
    skip,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES}/creatable`,
      method: "get",
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id } = {}) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: API_ORDER_TEMPLATES,
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES}/${id}`,
      method: "patch",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateConfigById: async ({
    id,
    data,
    modifiedOn,
    toastMessageConfig,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES}/${id}`,
      method: "patch",
      data,
      modifiedOn,
    });
    return apiRequest(options, toastMessageConfig);
  },
  configEmail: {
    getById: async ({ orderId }) => {
      const options = await apiOptions({
        url: `${API_ORDER_TEMPLATES}/${orderId}/email-configs`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options);
    },
    update: async ({ orderId, data, toastMessageConfig }) => {
      const options = await apiOptions({
        url: `${API_ORDER_TEMPLATES}/${orderId}/email-configs`,
        method: "post",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
};
